const transition = {
  x: { duration: 0.5, delay: 0.1 },
  zIndex: { duration: 0, delay: 0.6 },
};

export const buttonVariants = {
  show: { x: 0, zIndex: 100, transition },
  hidden: { x: -50, zIndex: -1, transition },
};
